import usersService from '@/services/UsersService';

export default {
	namespaced: true,
	//#region [ State ]
	state: {
		users: [],
		user: {}
	},
	//#endregion

	//#region [ Mutations ]
	mutations: {
		setUsers(state, payload) {
			state.users = payload;
		},

		setUser(state, payload) {
			state.user = payload;
		}
	},
	//#endregion

	//#region [ Actions ]
	actions: {
		async getUsers({ commit }) {
			try {
				const data = await usersService.getAll();
				commit('setUsers', data);
				return data;
			} catch (error) {
				console.log(error);
			}
		},

		// eslint-disable-next-line no-unused-vars
		async saveRole({ commit }, userData) {
			try {
				const data = await usersService.saveRolAsync(userData);
				return data;
			} catch (error) {
				console.log(error);
			}
		},

		async getUserById({ commit }, id) {
			try {
				const data = await usersService.getUserByIdAsync(id);
				if (data.Code === 200) {
					commit('setUser', data.Data);
					return data;
				}
			} catch (error) {
				console.log(error);
			}
		}
	},
	//#endregion

	//#region [ Getters ]
	getters: {}
	//#endregion
};
